import { render, staticRenderFns } from "./ImportProjectStatus.vue?vue&type=template&id=66d671b7&scoped=true&"
import script from "./ImportProjectStatus.vue?vue&type=script&lang=js&"
export * from "./ImportProjectStatus.vue?vue&type=script&lang=js&"
import style0 from "./ImportProjectStatus.vue?vue&type=style&index=0&id=66d671b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d671b7",
  null
  
)

export default component.exports